import toast from "react-hot-toast";
import type { Task } from "../types";

/**
 * Titles for a delete that already has its ids, in that same order.
 * A missing row keeps an empty title so the count still matches the delete.
 */
export function deletedSubtaskTitles(
  tasks: Task[] | undefined,
  ids: readonly string[],
): string[] {
  const byId = new Map<string, string>();
  for (const task of tasks ?? []) {
    for (const subtask of task.subtasks ?? []) {
      byId.set(subtask.id, subtask.title);
    }
  }
  return ids.map((id) => byId.get(id) ?? "");
}

/**
 * Confirms a delete that already succeeded, in the same shape as a new
 * sub-task: one names itself, several share one count. A deleted sub-task
 * has nowhere to open, so the message is plain text. An edit never calls this.
 */
export function confirmDeletedSubtasks(titles: string[]): void {
  if (titles.length === 0) return;
  if (titles.length === 1) {
    const title = titles[0];
    toast.success(title ? `"${title}" deleted` : "Subtask deleted");
    return;
  }
  toast.success(`${titles.length} subtasks deleted`);
}
